import { useState, useEffect, useCallback } from "react";
import { ShowHideSubTable } from "../../components/ShowHideSubTable";
import {
  getWasteSubcategory,
  deleteWasteSubcategory,
  updateWasteSubcategory,
  createWasteSubcategory,
} from "../../../../../apis/Business/WasteApi";
import SubcategoryBox from "../../components/SubcategoryBox";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import CustomWasteTable from "./Table/CustomWasteTable";

const CustomWasteContents = ({ businessId }) => {
  const [showTable, setShowTable] = useState();
  const [customSubcategories, setCustomSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const { invalidateKey, resetKey } = useInvalidateQuery();
  const key = "add-new-surplus-resource-subcategory";
  const deleteKey = "delete-surplus-resource-subcategory";

  useEffect(() => {
    getWasteSubcategory({
      businessId: businessId,
      setCustomSubcategory: setCustomSubcategories,
    });
  }, [businessId]);

  const handleSaveSubcategory = (subcategoryData) => {
    if (subcategoryData.objectId) {
      updateWasteSubcategory(subcategoryData)
        .then(() => {
          setCustomSubcategories((prevSubcategories) =>
            prevSubcategories.map((sub) =>
              sub.id === subcategoryData.objectId ? subcategoryData : sub
            )
          );
        })
        .catch((err) => console.error(err));
    } else {
      createWasteSubcategory(subcategoryData)
        .then((newSubcategory) => {
          setCustomSubcategories((prevSubcategories) => [
            ...prevSubcategories,
            newSubcategory,
          ]);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleInvalidateAndReset = useCallback(
    (setSubcategoryCustom, setSubcategoryDescCustom, isNewSubcategory) => {
      if (invalidateKey === key || invalidateKey === deleteKey) {
        getWasteSubcategory({
          businessId: businessId,
          setCustomSubcategory: setCustomSubcategories,
        });
        if (isNewSubcategory) {
          setSubcategoryCustom("");
          setSubcategoryDescCustom("");
        }
      }
      resetKey();
    },
    [businessId, resetKey, invalidateKey, key, deleteKey]
  );

  useEffect(() => {
    handleInvalidateAndReset(
      () => {},
      () => {}
    );
  }, [invalidateKey, businessId, handleInvalidateAndReset]);

  const handleDeleteSubcategory = (subcategoryData) => {
    deleteWasteSubcategory(subcategoryData)
      .then(() => {
        setCustomSubcategories((prevSubcategories) =>
          prevSubcategories.filter((sub) => sub.id !== subcategoryData.objectId)
        );
      })
      .catch((err) => console.error(err));
  };

  const handleEditSubcategory = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };
  return (
    <div className="component-energy-contents">
      <div style={{ marginTop: "12px" }}>
        <SubcategoryBox
          businessId={businessId}
          createSubcategoryApi={handleSaveSubcategory}
          handleInvalidateAndReset={handleInvalidateAndReset}
          isNewSubcategory={true}
        />
        {Array.isArray(customSubcategories) &&
          customSubcategories.length > 0 &&
          customSubcategories.map((sub, index) => {
            return (
              <div style={{ position: "relative" }}>
                <SubcategoryBox
                  key={sub.id}
                  subcategory={sub.name}
                  subcategoryDesc={sub.description}
                  subcategoryId={sub.id}
                  businessId={businessId}
                  createSubcategoryApi={createWasteSubcategory}
                  deleteSubcategoryApi={handleDeleteSubcategory}
                  updateSubcategoryApi={handleSaveSubcategory}
                  onEdit={handleEditSubcategory}
                  isLetter={true}
                  baseSequence={"8.1.1"}
                  index={index}
                  handleInvalidateAndReset={handleInvalidateAndReset}
                />
                {showTable === sub.id && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginRight: "80px",
                        marginTop: "40px",
                      }}
                    >
                      <h5 style={{ color: "rgb(25, 54, 102)" }}>
                        Selling your surplus materials
                      </h5>
                    </div>
                    <CustomWasteTable
                      businessId={businessId}
                      subcategory={sub.name}
                      subcategory_description={sub.description}
                      subcategoryId={sub.id}
                    />
                  </>
                )}
                <ShowHideSubTable
                  showTable={showTable}
                  setShowTable={setShowTable}
                  subId={sub.id}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default CustomWasteContents;
